import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
//import propertytypesApi from "../../api/propertytype";
import {
  Button,
  Card,
  Table,
  Modal,
  Row,
  Col,
  Space,
  Image,
  Typography,
  message,
  Form,
  Switch,
  Flex,
} from "antd";
import _, { debounce } from "lodash";
import { useIntl } from "react-intl";
import IntlMessage from "../../../components/IntlMessage";
import userOperatorApi from "../../../api/user-operator";
import PageTitle from "../../../components/PageTitle";
import ActionBar from "../../../components/ActionBar";
import dayjs from "dayjs";
import { field_payment_method } from "../../../utils/constant";
import customersApi from "../../../api/customers";
import CustomerForm from "./customerForm";
import FilterBar from "../../../components/FilterBar";
const { Text, Link } = Typography;

const CustomerSetting = () => {
  // const isMount = useRef(false)

  const [total, setTotal] = useState(1);
  // const [deleting, setDeleting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [reload, setReload] = useState(true);
  const [usersOperator, setUsersOperator] = useState([]);
  const [condition, setCondition] = useState({});
  const [openModal, setOpenModal] = useState(false);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: "",
    order_by: "id",
    order_dir: "DESC",
  });
  const [currentData, setCurrentData] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await customersApi.getAllByOperator(filter);
        setTotal(res?.total);
        setLoading(false);
        if (res) {
          setUsersOperator(res?.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetch();
  }, [filter, reload]);

  useEffect(() => {
    if (filter?.filter_name && filter?.filter_value) {
      const newCondition = _.zipObjectDeep(
        filter?.filter_name,
        filter?.filter_value
      );
      setCondition(newCondition);
    }
  }, [filter]);

  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : "id",
    });
  };

  const onFilter = debounce(async (value, title, type) => {
    if (type === "search") {
      setFilter((filter) => {
        return { ...filter, keyword: value, page: 1 };
      });
    } else {
      const filter_obj = { ...condition, [title]: value };
      let filter_name = [];
      let filter_value = [];
      for (var key in filter_obj) {
        if (filter_obj[key]) {
          console.log("key", key);
          filter_name.push(key);
          filter_value.push(filter_obj[key]);
        }
      }
      setFilter((filter) => {
        return {
          ...filter,
          filter_name: filter_name,
          filter_value: filter_value,
        };
      });
    }
  }, 300);

  const onReload = () => {
    setReload((reload) => !reload);
  };

  const onOpenModal = () => {
    setOpenModal(true);
  };
  const onModalClose = () => {
    form.resetFields();
    setOpenModal(false);
    setCurrentData(null);
  };

  const intl = useIntl();

  const getOrder = (order) => {
    if (order === "ascend") return "ASC";
    if (order === "descend") return "DESC";
    return "DESC";
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onChangeStatus = async (record, checked) => {
    await customersApi
      .updateStatus(record.id, { status: checked })
      .catch((err) => {
        console.log(err);
      });
    setUsersOperator((data) => {
      return data.map((item) => {
        if (item.id === record.id) {
          return {
            ...item,
            status: checked,
          };
        }
        return item;
      });
    });
  };

  const onModalOpen = (record) => {
    setCurrentData(record);
    setOpenModal(true);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: <IntlMessage id="global.firstname" />,
      key: "firstname",
      dataIndex: "firstname",
      sorter: true,
      width: 250,
      render: (text, record, index) => {
        return (
          <Link
            onClick={() => onModalOpen(record)}
            style={{ fontSize: "small" }}
          >
            {record?.firstname}
          </Link>
        );
      },
    },
    {
      title: <IntlMessage id="global.lastname" />,
      key: "lastname",
      dataIndex: "lastname",
      sorter: true,
      width: 250,
      render: (text, record, index) => {
        return (
          <Text
            onClick={() => onModalOpen(record)}
            style={{ fontSize: "small" }}
          >
            {record?.lastname}
          </Text>
        );
      },
    },

    {
      title: <IntlMessage id="global.mobile" />,
      key: "mobile",
      dataIndex: "mobile",
      sorter: true,
      width: 250,
      render: (text, record, index) => {
        return (
          <Text
            onClick={() => onModalOpen(record)}
            style={{ fontSize: "small" }}
          >
            {record?.mobile}
          </Text>
        );
      },
    },

    {
      title: <IntlMessage id="global.status" />,
      key: "status",
      width: 150,
      dataIndex: "status",
      render: (text, record, index) => {
        return (
          <Flex justify="center">
            <Switch
              defaultValue={record.status}
              checked={text}
              onChange={() => onChangeStatus(record, !text)}
            />
          </Flex>
        );
      },
    },

    {
      title: <IntlMessage id="global.created_at" />,
      key: "created_at",
      width: 250,
      dataIndex: "created_at",
      sorter: true,
      render: (text, record, index) => {
        return (
          <Text>
            {dayjs(record?.payment_method?.created_at).format(
              "DD/MM/YYYY HH:mm"
            )}
          </Text>
        );
      },
    },
  ];

  const onDelete = async (id) => {
    try {
      const res = await customersApi.delete(id);
      if (res) {
        message.success("Successfully deleted user");
        onReload();
        setSelectedRowKeys([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Card bordered={false} style={{ minHeight: "100%" }}>
      <Row justify="space-between">
        <Col>
          {" "}
          <PageTitle title={<IntlMessage id="global.customers" />} />
        </Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onRefresh={onReload}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={true}
            deleteMessage={
              "Warning! You are about to delete this customer and its associated records. Are you sure you want to delete this record?"
            }
            isDisabled={!(selectedRowKeys.length > 0)}
          ></ActionBar>
        </Col>
      </Row>

      <br />

      <Flex vertical gap={12}>
        <FilterBar
          onFilter={onFilter}
          data={[
            {
              name: "status",
              data: [
                { title: "Active", value: "1" },
                { title: "Inactive", value: "0" },
              ],
              placeholder: <IntlMessage id="global.status" />,
            },
          ]}
        />

        <Table
          tableLayout="auto"
          scroll={{ x: "max-content" }}
          columns={columns}
          dataSource={usersOperator}
          onChange={onChangeTable}
          rowKey="id"
          size="small"
          loading={loading}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50"],
            total: total,
            current: filter.page,
            pageSize: filter.limit,
          }}
          rowSelection={rowSelection}
        />
      </Flex>

      {openModal ? (
        <CustomerForm
          isModalOpen={openModal}
          setOpenModal={setOpenModal}
          onModalClose={onModalClose}
          currentData={currentData}
          onRefresh={onReload}
          setUsersOperator={setUsersOperator}
          usersOperator={usersOperator}
        />
      ) : null}
    </Card>
  );
};

export default CustomerSetting;
